import gql from 'graphql-tag';

export const EFAKTURA_SETUP = gql`
  query efakturaSetup {
    efakturaSetup
  }
`;
